import React, { useEffect, useState } from "react";
import "../assets/css/quoteModal.css";
import axios from "axios";

const QuoteModal = ({ isOpen, onClose, productName }) => {
    const [visible, setVisible] = useState(false);
    const backendUrl = process.env.REACT_APP_BACKEND_URI
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        application: "",
        message: ""
    });

    useEffect(() => {
        if (isOpen) setVisible(true);
        else setTimeout(() => setVisible(false), 300);
    }, [isOpen]);

    if (!isOpen && !visible) return null;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await axios.post(
                `${backendUrl}/api/quote`,
                {
                    name: formData.name,
                    email: formData.email,
                    mobile: formData.mobile,
                    countryCode: "+91",
                    product: productName || "General Quote",
                    application: formData.application,
                    message: formData.message
                },
                { timeout: 8000 }
            );

            alert("Quote request sent successfully!");
            onClose();
        } catch (error) {
            console.error(error.response?.data); // 🔥 LOG BACKEND MESSAGE
            alert(error.response?.data?.message || "Failed to send quote");
        }
    };

    return (
        <div className={`quote-overlay ${isOpen ? "show" : "hide"}`}>
            <div className={`quote-modal ${isOpen ? "show" : "hide"}`}>
                <button className="quote-close-btn" onClick={onClose}>✕</button>

                <h2 className="quote-title">GET INSTANT QUOTE</h2>

                <form className="quote-form" onSubmit={handleSubmit}>
                    <div className="quote-row">
                        <div className="quote-field">
                            <label>Your name</label>
                            <input type="text" name="name" onChange={handleChange} required />
                        </div>

                        <div className="quote-field">
                            <label>Email</label>
                            <input type="email" name="email" onChange={handleChange} required />
                        </div>
                    </div>

                    <div className="quote-row">
                        <div className="quote-field">
                            <label>Mobile</label>
                            <input type="text" name="mobile" onChange={handleChange} required />
                        </div>

                        <div className="quote-field">
                            <label>Application / Industry Type</label>
                            <input type="text" name="application" onChange={handleChange} />
                        </div>
                    </div>

                    <div className="quote-field full-width">
                        <label>Service</label>
                        <textarea name="message" onChange={handleChange}></textarea>
                    </div>

                    <button className="primary-btn" style={{ padding: '15px 25px', width: 'fit-content',backgroundColor:'#fff', color:'#0f766e' }}>
                        <span className="btn-text-wrap">
                            <span className="btn-text">I'd Like a Quote</span>
                            <span className="btn-text btn-text-abs">I'd Like a Quote</span>
                        </span>
                    </button>
                </form>
            </div>
        </div>
    );
};

export default QuoteModal